import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalComponent } from '../shared/modal/modal.component';
import { Subject } from 'rxjs';
import { UserService } from '../services/usre.service';
import { DataTransferService } from '../services/DataTransferService';
import { TableService } from '../services/table.service';
import { LocationService } from '../services/location.service';
import { LanguageService } from '../services/language/language.service';
import { Rtipopservice } from '../services/rtipopservice.service';



// const rtlBootstrap = '//cdn.rawgit.com/morteza/bootstrap-rtl/v3.3.4/dist/css/bootstrap-rtl.min.css';
// const rtlTheme = 'assets/theme/theme.rtl.css';
@Component({
  selector: 'app-private',
  templateUrl: './private.component.html',
  styleUrls: ['./private.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({
        opacity: 1,
        display: 'block'
      })),
      state('closed', style({
        opacity: 0,
        display: 'none'
      })),
      transition('open => closed', [
        animate('0.5s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ]),
  ]
})
export class PrivateComponent implements OnInit {
  private ngUnsubscribe = new Subject();

  @ViewChild('modalError')
  displayErrorRef: ModalComponent;
  // safeUrl: any = this.sanitizer.bypassSecurityTrustResourceUrl(localStorage.getItem('lang') == 'en' ? '' : (localStorage.getItem('lang') == 'ar' ? rtlBootstrap : ''));
  // safeUrl2: any = this.sanitizer.bypassSecurityTrustResourceUrl(localStorage.getItem('lang') == 'en' ? '' : (localStorage.getItem('lang') == 'ar' ? rtlTheme : ''));
  branch: any;
  isBranchOpened: boolean = true;
  currentUser: any = {};
  userLocationId: any;
  constructor(public sanitizer: DomSanitizer,
    private location: LocationService,
    private router: Router, private user: UserService, private userContext: TableService,
    private dataTransfer: DataTransferService, private route: ActivatedRoute,
    private languageService: LanguageService) 
  {
    if (localStorage.getItem('lang') == undefined || localStorage.getItem('lang') == null)
      localStorage.setItem('lang', 'en')
  }
  onLangChange(event) {
    var langObject = event;

    // if (langObject.langObject == "ar") {

    //   this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(rtlBootstrap)
    //   this.safeUrl2 = this.sanitizer.bypassSecurityTrustResourceUrl(rtlTheme);
    //   localStorage.setItem('lang', langObject.langObject)
    // }
    // else if (langObject.langObject == "en") {

    //   this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('')
    //   this.safeUrl2 = this.sanitizer.bypassSecurityTrustResourceUrl('');
    //   localStorage.setItem('lang', langObject.langObject)
    // }
    localStorage.setItem('lang', langObject.langObject)
    this.languageService.changeLanguage(langObject.langObject);
  }

  onBranchSelect(event) {
    this.branch = event;
    this.isBranchOpened = this.branch == null ? true : false;
    //this.router.navigate(['/dashboard'])
    // Input for header
    this.dataTransfer.setSelectedBranch(event);
    this.currentUser = JSON.parse(sessionStorage.getItem("user"))
  }
  disableSideMenu = false;
  onBranchSelectionAction(event) {
    
    this.disableSideMenu = event;
  }

  onChangeBranchRequest(event) {
    
    var company = JSON.parse(sessionStorage.getItem("company"));
    if (company.Branches.length > 1) {
      this.isBranchOpened = true;
      this.disableSideMenu = false;
    }
  }

  ngOnInit() {
    
    var c = this.route.paramMap.subscribe(x => {
      var userName = x as any
      if (userName.params.username != undefined) {
        sessionStorage.setItem('username', userName.params.username)
      }
    })
  }
}
